import request from '@/utils/http'

const AI_REQUEST_TIMEOUT = 60000

const unwrapResult = (response) => {
  const code = Number(response?.code ?? 200)
  if (Number.isFinite(code) && code !== 200) {
    throw new Error(response?.message || response?.msg || 'AI 助手请求失败')
  }
  return response?.data ?? response
}

const callAssistant = async (config) => {
  const response = await request({
    timeout: AI_REQUEST_TIMEOUT,
    ...config,
  })
  return unwrapResult(response)
}

export const assistantApi = {
  fetchStatus() {
    return callAssistant({
      url: '/mall/ai/assistant/status',
      method: 'get',
      timeout: 15000,
    })
  },

  chat(data) {
    return callAssistant({
      url: '/mall/ai/assistant/chat',
      method: 'post',
      data,
    })
  },

  parseOrder(data) {
    return callAssistant({
      url: '/mall/ai/order/parse-match',
      method: 'post',
      data,
    })
  },

  parseOrderWithFiles(data) {
    return callAssistant({
      url: '/mall/ai/order/parse-match-with-files',
      method: 'post',
      data,
    })
  },

}
